<template>
    <b-form
        :save-url="addUrl"
        @success="formSuccess"
        @failure="formFailure"
        v-slot="{model, loading}"
        :save-params="{api_key: currentUser.api_key}"
    >

        <div class="row">
            <validated-input
                class="col-12"
                label="Heading"
                name="Heading"
                v-model="model.heading"
                :rules="{required:true}"
                :disabled="loading"
            />
        </div>

        <div class="row">
            <div class="file-upload-wrapper col-6">
    <label class="field-label">Profile Image</label>

    <div
        class="custom-file-input"
        @click="triggerFileInput(loading)"
    >
        <span>{{ model.profile_img ? model.profile_img.name : 'Browse' }}</span>
    </div>

    <input
        ref="fileInput"
        type="file"
        class="hidden-file-input"
        accept="image/*"
        :disabled="loading"
        @change="handleFileChange($event, model)"
    />
</div>
        </div>

        <div class="row">
            <div class="col">
                <image-info :width="380" :height="380"/>
            </div>
        </div>

        <div class="row">
            <validated-textarea
                class="col-12"
                label="Para 1"
                name="Para 1"
                v-model="model.para_1"
                :rules="{required:true, min:540, max:560}"
                :disabled="loading"
            />
        </div>

        <div class="row">
            <validated-textarea
                class="col-12"
                label="Para 2"
                name="Para 2"
                v-model="model.para_2"
                :rules="{required:true, min:540, max:560}"
                :disabled="loading"
            />
        </div>

        <div class="row">
            <checkbox-input
                class="col-6"
                label="Disable"
                v-model="model.disabled"
                :rules="{required:false}"
                :disabled="loading"
            />
        </div>

        <btn
            class="trn"
            size="sm"
            :loading="loading"
            color="primary"
            text="Save"
            loading-text="Saving..."
            :disabled="loading"
        />
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name : 'AddAboutUsProfile',

    computed : {
        ...mapGetters(['currentUser'])
    },

    data () {
        return {
            addUrl : urls.admin.event.aboutUsProfile.addEdit
        };
    },

    methods : {
        triggerFileInput (loading) {
            if (!loading) {
                this.$refs.fileInput.click();
            }
        },

        handleFileChange (event, model) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                if (image.width !== 380 || image.height !== 380) {
                    this.$notify(
                        'Please upload an image with dimensions 380 × 380 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    event.target.value = '';
                    model.profile_img = null;
                    return;
                }

                this.$set(model, 'profile_img', file);

                console.log(model.profile_img);
            };

            image.src = URL.createObjectURL(file);
        },

        formSuccess () {
            this.$notify(
                'Successfully Added About Us Profile...!',
                'Success',
                {
                    type : 'success'
                }
            );

            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;

            if (json.permission === false) {
                this.$notify(
                    'Invalid Authentication..!',
                    'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
                return;
            }

            if (json.errors) {
                Object.entries(json.errors).forEach(([field, message]) => {
                    this.$notify(
                        `${field}: ${Array.isArray(message) ? message[0] : message}`,
                        'Validation Error',
                        {
                            type : 'warning'
                        }
                    );
                });

                return;
            }

            this.$notify(
                'Something went wrong!',
                'Error',
                {
                    type : 'error'
                }
            );
        }
    }
};
</script>

<style scoped>
.hidden-file-input {
    display: none;
}

.custom-file-input {
    width: 100%;
    height: 38px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 14px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    background-color: white;
    cursor: pointer;
    color: black;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
</style>
